/** Canonical circular selection checkmark — shared sizing tokens. */
export const SELECTION_CHECK_BADGE_SIZE_PX = 22
export const SELECTION_CHECK_GLYPH_SIZE_PX = 12

export function selectionCheckShadow(color: string, alpha = 0.35): string {
  return `0 2px 8px color-mix(in srgb, ${color} ${Math.round(alpha * 100)}%, transparent)`
}
